import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@material-ui/core'
import clsx from 'clsx'

import { ShipmentTour } from 'common/models/typings/Tour'

import Typography from 'common/components/base/Typography'

import useStyles from './useStyles'
import Icon from 'common/components/base/Icon'

export interface FuelTypeProps {
  vehicleType: ShipmentTour['vehicleType']
  disabled: boolean
}

const VehicleBadge: React.FC<FuelTypeProps> = ({ vehicleType, disabled }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <div>
      <Icon
        name={vehicleType === 'fossil' ? 'fossil' : 'electric'}
        className={clsx('w-4 h-4', {
          'text-green-50': vehicleType === 'electric',
          'text-orange-50': vehicleType === 'fossil',
        })}
      />
    </div>
  )
}

export default VehicleBadge
